import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';

import type {
  getVerifyStatusResponse,
  Profile,
  ProfileProps,
  ProfilePropsImmu,
  verifyIdentityResponse,
  verifyPayload,
} from './profileTypes';

const syncProfilePayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<ProfilePropsImmu>>();
const profilePayloadCreator = getPayloadCreator<Profile | ProfileProps>();

export const getProfile = createAction('GET_PROFILE', getPayloadCreator());
export const getProfileSuccess = createAction('GET_PROFILE_SUCCESS', syncProfilePayloadCreator);
export const getProfileFailure = createAction('GET_PROFILE_FAILURE', errorPayloadCreator);

export const updateProfile = createAction('UPDATE_PROFILE', profilePayloadCreator);
export const updateProfileSuccess = createAction('UPDATE_PROFILE_SUCCESS', syncProfilePayloadCreator);

export const verifyEmail = createAction('VERIFY_EMAIL', getPayloadCreator());
export const verifyEmailSuccess = createAction('VERIFY_EMAIL_SUCCESS'); // TODO: maybe do something with success?
export const verifyEmailFailure = createAction('VERIFY_EMAIL_FAILURE', errorPayloadCreator);

export const createPhone = createAction('CREATE_PHONE', getPayloadCreator());
// create is actually done on quicken.com myAccount page in a new tab, this just triggers client-side polling in the sagas
export const verifyPhone = createAction('VERIFY_PHONE', getPayloadCreator());
export const verifyPhoneSuccess = createAction('VERIFY_PHONE_SUCCESS'); // TODO: maybe do something with success?
export const verifyPhoneFailure = createAction('VERIFY_PHONES_FAILURE', errorPayloadCreator);

export const getVerificationStatus = createAction('GET_VERIFICATION_STATUS', getPayloadCreator());
export const getVerificationStatusSuccess = createAction(
  'GET_VERIFICATION_STATUS_SUCCESS',
  getPayloadCreator<getVerifyStatusResponse>(),
);
export const getVerificationStatusFailure = createAction('GET_VERIFICATION_STATUS_FAILURE', errorPayloadCreator);

export const verifyIdentity = createAction('VERIFY_IDENTITY', getPayloadCreator<verifyPayload>());
export const verifyIdentitySuccess = createAction(
  'VERIFY_IDENTITY_SUCCESS',
  getPayloadCreator<verifyIdentityResponse>(),
);
export const verifyIdentityFailure = createAction('VERIFY_IDENTITY_FAILURE', errorPayloadCreator);
